import {
  SnippetElement,
  defineElement,
  on,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/shop-service-accordion/shop-service-accordion.ts
var ShopServiceAccordion = class extends SnippetElement {
  handleClick() {
    this.accordion.toggle();
    this.chevron.classList.toggle("rotate-180");
  }
};
__decorateClass([
  query("[data-accordion]")
], ShopServiceAccordion.prototype, "accordion", 2);
__decorateClass([
  query("[data-chevron]")
], ShopServiceAccordion.prototype, "chevron", 2);
__decorateClass([
  on("click", "[data-open-button]")
], ShopServiceAccordion.prototype, "handleClick", 1);
ShopServiceAccordion = __decorateClass([
  defineElement("shop-service-accordion")
], ShopServiceAccordion);
export {
  ShopServiceAccordion
};
